import React, { useEffect, useState } from "react";
import "./FilterList.scss";
import { DateType, FilterMapping, TabMoreMapping } from "../../features/searchpage/constants/filters.constants";
import { areParamsEqual, checkArrayInArray, getFilterKeyByApiKey } from "../../utils/globalUtilities";
import MultiFieldSelection from "../multi-field-selection/multi-field-selection";
import Selection from "../selection/selection";
import MoreFilters from "./MoreFilters/MoreFilters";
import SubjectFilter from "../subject-filter/subject-filter";
import FilterListShimmer from "./FilterListShimmer";
import _ from 'lodash'

interface FilterItem {
  id: string;
  name: string;
  ordering: number;
}

type FilterListsType = {
  [key: string]: FilterItem[];
};

interface FilterListProps {
  filterLists?: any;
  onFilterFormDataChange?: Function,
  exsistingfilters: any,
  tab: any,
  onSetSubjectFilter?: Function,
  subjectText?: any,
  subjectType?: string,
  filerPreSelection?:any
}

const FilterList: React.FC<FilterListProps> = ({ filterLists, onFilterFormDataChange, exsistingfilters, tab, onSetSubjectFilter, onSetSubjectType, subjectText, filerPreSelection }) => {
  const [filterFormData, setFilterFormData] = useState<any>({});
  const [filterData, setFilterData] = useState<any>({});
  const [showMoreFilters, setShowMoreFilters] = useState<boolean>(false);
  const [isMoreFilterExist, setIsMoreFilterExist] = useState<boolean>(true);
  const [filtersSelction, setFiltersSelction] = useState<any>([]);
  const [extraFiltersSelction, setExtraFiltersSelction] = useState<any>([]);
  const [moreFilters, setMoreFilters] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(true);

  const debouncedSetLoading = _.debounce((value) => {
    setLoading(value);
  }, 300);

  useEffect(() => {
    setLoading(true);
    
    if (filterLists && Object.keys(filterLists).length > 0) {
      setFilterData(filterLists);
      debouncedSetLoading(false);
    }
    
    return () => {
      debouncedSetLoading.cancel();
    };
  }, [filterLists, exsistingfilters, tab, filerPreSelection]);

  useEffect(() => {
    if(filterLists && Object?.keys(filterLists)?.length > 0){
    if (Object?.keys(filerPreSelection)?.length > 0) {
      let preSelection = {...filerPreSelection};
      let newFilterFormData: any = {};
      Object.keys(preSelection).forEach((key: any) => {
          let keyMap = getFilterKeyByApiKey(key);
          if(keyMap?.length){
          let filterListData = {...filterLists}
            let filterData = filterListData[keyMap];
            if (filterData?.length) {
              let selectedItems = preSelection[key];
              let newData: any = {};
              newData[key] = [];
              if(selectedItems?.length){
              selectedItems.forEach((item: any) => {
                let index = filterData.findIndex((data: any) => data.id == item);
                if (index >= 0) {
                  newData[key].push(filterData[index]);
                }
              });
            }
              newFilterFormData[key] = newData[key];
            }
          }
      });
      setFilterFormData(newFilterFormData);
    }
  }
  }, [filterLists,filerPreSelection]);


  const toggleFilter = (apikey: string, data: any) => {
    let previousFilterFormData = { ...filterFormData };
    let currentSelection = previousFilterFormData[apikey] ? [...previousFilterFormData[apikey]] : [];
    const index = currentSelection.findIndex((selection: any) => selection.id === data.id);
  
    if (index >= 0) {
      currentSelection.splice(index, 1);
    } else {
      currentSelection.push(data);
    }
  
    const newData = {
      ...previousFilterFormData,
      [apikey]: currentSelection,
    };
  
    setFilterFormData(newData);
  };
  const toggleFilterSelection = (apikey: string, data: any) => {
    let previousFilterFormData = filterFormData;
    // Add item if not selected
    let newData = {
      ...previousFilterFormData,
      [apikey]: [data],
    };
    setFilterFormData(newData)
  }

  useEffect(() => {
      if (!areParamsEqual(exsistingfilters, filterFormData)) {
        setFilterFormData(exsistingfilters)
      }
      let filtersAll = { ...exsistingfilters };
      // remove empty filters
      let totalCount = 0;
      // separate lists of filters
      let selectionData: any = [];
      let allkeys = Object.keys(filtersAll);
      // get only keys of filters outside, no more filters
      let keys: any = [];
      let filterMappingKeys = Object.keys(FilterMapping);
      let defaultFilterKeys: any = [];
      filterMappingKeys.forEach((key: string) => {
        defaultFilterKeys.push(FilterMapping[key].apiKey);
      });
      allkeys.forEach((key: string) => {
        if (defaultFilterKeys.indexOf(key) >= 0) {
          keys.push(key);
        }
      });
      keys.forEach((key: string) => {
        filtersAll[key].forEach((element: any) => {
          let data = {
            key: key,
            name: element.name,
            id: element.id
          }
          selectionData.push(data)
        });
      });
      totalCount = selectionData.length;
      if (totalCount > 10) {
        setFiltersSelction(selectionData.slice(0, 10));
        setExtraFiltersSelction(selectionData.slice(10, totalCount));
      } else {
        setFiltersSelction(selectionData);
      }
  }, [exsistingfilters]);

  
  // useEffect(() => {
  //     // remove empty filters
  //     let totalCount = subjectText.length + filtersSelction.length + extraFiltersSelction.length;
  //     // separate lists of filters
  //     let selectionData =  [...filtersSelction, ...extraFiltersSelction];
  //       subjectText.forEach((element: any) => {
  //         if(selectionData.indexOf(element) == -1){
  //         let data = {
  //           key: 'subjectList',
  //           name: element,
  //           id: ''
  //         }
  //         selectionData.push(data)
  //       }
  //       });
  //     if (totalCount > 10) {
  //       setFiltersSelction(selectionData.slice(0, 10));
  //       setExtraFiltersSelction(selectionData.slice(10, totalCount));
  //     } else {
  //       setFiltersSelction(selectionData);
  //     }
  // }, [subjectText]);

  useEffect(() => {
    if (filterFormData && Object?.keys(filterFormData)?.length > 0) {
      onFilterFormDataChange(filterFormData)
    }
  }, [filterFormData]);

  const onRemoveFilterSelection = (selectedData: any, index: number) => {
    let previousFilterFormData = filterFormData;
    if(selectedData.key == 'subjectList'){
      let subjects = [...subjectText];
      let indexFound  = subjects.findIndex((subject:string)=> subject == selectedData.name);
     subjects.splice(indexFound, 1);
      onSetSubjectFilter(subjects)
    }else{
    let currentSelection = previousFilterFormData[selectedData.key] || [];
    let indexSelection = currentSelection.findIndex((selection: any) => selection.id == selectedData.id);
    let newData: any
    if (indexSelection >= 0) {
      currentSelection.splice(indexSelection, 1)
      newData = {
        ...previousFilterFormData,
        [selectedData.key]: currentSelection,
      };
    }
    setFilterFormData(newData)
  }
  }

  useEffect(() => {
    if (tab?.id) {
      let isFound = checkArrayInArray(TabMoreMapping, tab.id);
      setIsMoreFilterExist(isFound);
    }else{
      setIsMoreFilterExist(true);  
    }
  }, [tab]);

  const onMoreFilterFormDataChange = (morefilter: any) => {
    let newData = {
      ...filterFormData,
      ...morefilter,
    };
    setFilterFormData(newData)
    setMoreFilters(morefilter)
    setShowMoreFilters(false);
  }

  const onReset = () => {
    let selectionFilter = { ...exsistingfilters };
    let keys = Object.keys(selectionFilter);
    keys.forEach((key: string) => {
      selectionFilter[key] = [];
    });
    onSetSubjectFilter([]);
    setFilterFormData(selectionFilter);
    onFilterFormDataChange(selectionFilter);
  }

  const onChangeSubjectFilter = (subjects: any) => {
    onSetSubjectFilter(subjects);
  }

  const onChangeSubjectType = (subjectType: string) => {
    onSetSubjectType(subjectType);
  }

  const isMoreFilterApplied = () => {
    let isApplied = false;
    Object.keys(moreFilters).forEach((key) => {
      if (filterFormData[key]?.length > 0  ) {
        isApplied = true;
      }else if (typeof filterFormData[key] == 'object' && filterFormData[key] !== null) {
        if (filterFormData[key] instanceof Date) {
          isApplied = true;
        }
      }
    });
    return isApplied;
  }

  const handleMoreFiltersClose = () => {
    setShowMoreFilters(false);
  };

  return (
    <div className="ui-filter" key={`Filters`} >

      <div className="ui-filter-flex" key={`List`} >
        <ul className="ui-filter-items ui-filter-flex-colls ui-filter-flex-auto" key={`FilterList`} >
        {loading ? (
            <FilterListShimmer />
          ) : (
            filterData && Object.keys(filterData).length ? 
              FilterMapping && Object.keys(FilterMapping).length ? 
                Object.keys(FilterMapping).map((key, index) =>
                  FilterMapping[key]['dataType'] === DateType.MULISELECT && filterData[key]?.length ? (
                    <MultiFieldSelection
                      key={`MultiFieldSelectionMap${index}`}
                      fieldKey={key}
                      items={filterData[key]}
                      toggleFilter={toggleFilter}
                      selectedFilters={filterFormData}
                      index={index}
                    />
                  ) : FilterMapping[key]['dataType'] === DateType.SELECT && filterData[key]?.length ? (
                    <Selection
                      key={`FieldSelectionMap${index}`}
                      fieldKey={key}
                      items={filterData[key]}
                      toggleFilterSelection={toggleFilterSelection}
                      selectedFilters={filterFormData}
                    />
                  ) : FilterMapping[key]['dataType'] === DateType.AUTOCOMPLETE ? (
                    <SubjectFilter
                      key={`SubjectSelectionMap${index}`}
                      tab={tab}
                      fieldKey={'Subject'}
                      onChangeSubjectFilter={onChangeSubjectFilter}
                      onChangeSubjectType={onChangeSubjectType}
                      subjectText={subjectText}
                    />
                  ) : null
                )
              : null
            : null
          )}
        </ul>
        {isMoreFilterExist && !loading ? (
          <div className="ui-filter-flex-colls" key={`MoreFilterOption`} >
            <a className={`button-links grey-link mt-1 pt-1 cursor-pointer ${isMoreFilterApplied() ? 'active' : ''}`} onClick={() => setShowMoreFilters(true)} >
              More Filters
            </a>
          </div>
        ) : ''}


        {!loading &&showMoreFilters && (
          <MoreFilters 
            tab={tab} 
            onMoreFilterFormDataChange={onMoreFilterFormDataChange} 
            exsistingMorefilters={exsistingfilters}
            onClose={handleMoreFiltersClose}
          />
        )}


      </div>

      {
        // Object.keys(filterFormData)?.length || subjectText?.length ?
        filtersSelction?.length || extraFiltersSelction?.length ?
          <div className="ui-filter-flex selected-filters" key={`FilterSelectionRow`} >
            {!loading && <ul className="selected-lists ui-filter-flex-colls ui-filter-flex-auto" key={`FilterSelectionsUL`} >
             
              {
                filtersSelction?.length ?
                  filtersSelction.map((selectedData: any, index: number) => (
                    <li key={`Selection${selectedData.id}`} >
                      {selectedData?.name}
                      <span className="chips-close" onClick={() => { onRemoveFilterSelection(selectedData, index) }}> <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.5 2.5L9.5 9.5" stroke="#C9C9C9" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M2.5 9.5L9.5 2.5" stroke="#C9C9C9" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      </span>
                    </li>
                  ))
                  : ''
              }
            </ul>}
            <div className="ui-filter-flex-colls" key={`MoreFilterSelectionRow`} >
              <ul className="selected-list-options" key={`MoreFilterSelectionUL`} >
                {
                  extraFiltersSelction?.length ?
                    <li className="dropdowns">
                      <a className="button-links grey-link cursor-pointer">
                        +{extraFiltersSelction.length}  More
                      </a>

                      <span className="dropdown-contents">
                        <span className="selected-h1"> Applied Filters </span>
                        <ul className="selected-lists" key={`AppliedFilterList`}  >
                          {
                            extraFiltersSelction.map((selectedData: any, index: number) => (
                              <li key={`MoreSelection${selectedData.id}`} >
                                {selectedData?.name}
                                <span className="chips-close" onClick={() => { onRemoveFilterSelection(selectedData, index) }}> <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M2.5 2.5L9.5 9.5" stroke="#C9C9C9" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M2.5 9.5L9.5 2.5" stroke="#C9C9C9" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                </span>
                              </li>
                            ))
                          }
                          {/* <li>
                  Income Tax
                  <span className="chips-close" onClick={() => { onRemoveFilterSelection(key, index) }}> <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.5 2.5L9.5 9.5" stroke="#C9C9C9" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M2.5 9.5L9.5 2.5" stroke="#C9C9C9" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  </span>
                </li> */}

                        </ul>
                      </span>
                    </li>
                    : ''
                }
                
              {!loading && <li>  <a className="button-links grey-link cursor-pointer" onClick={() => onReset()} >
                  Reset
                </a> </li>}
                
              </ul>

            </div>
          </div>
          : ''
      }
    </div>
  );
};

export default FilterList;
